<template>     
    <header class="color-bg-gradient p-4 pb-0">
        <div class="custom-container d-flex flex-column flex-xl-row align-items-xl-center gap-2 gap-md-0 pt-1 pt-md-2 ps-2 pe-2 ps-md-3 pe-md-3 mt-4 mt-md-5 m-auto">
            <div class="custom-container-header d-flex flex-column align-items-center align-items-md-start gap-2 gap-md-3 flex-shrink-0 m-auto m-md-0">
                <h1 class="text-headline-bold text-display-lg-bold color-text-contrast-light user-select-none mt-0 mb-1 mb-md-0">
                    {{ t('aboutPage.header.title') }}
                </h1>
                <p class="text-body-regular text-body2-lg-regular color-text-contrast-light text-center text-md-start user-select-none pb-1 pb-md-0 mb-2">
                    {{ t('aboutPage.header.paragraph') }}
                </p>
                <a class="button button--light w-auto ps-4 pe-4" type="button" @click="goToMail" target="_blank">
                    <span class="button__text text-body-semibold ps-2 pe-2">
                        {{ t('aboutPage.header.linkText') }}
                    </span>
                </a>
            </div>
            <img class="custom-image-header position-relative user-select-none" src="images/about-content-image-1.webp" alt="WebMoney Mail"/>
        </div>
    </header>
    <main class="custom-container-figure-bg color-bg-primary">
        <div class="custom-container d-flex flex-column gap-5 pt-5 ps-3 pe-3 ps-md-4 pe-md-4 m-auto">
            <div class="d-flex flex-column gap-2 pt-sm-3 pt-lg-5 mt-lg-1">
                <h2 class="text-headline-bold text-headline1-sm-bold color-text-contrast-shadow text-center text-md-start user-select-none W-100 mb-3">
                    {{ t('aboutPage.main.work.title') }}
                </h2>
                <div class="d-flex flex-column flex-lg-row gap-2 gap-lg-4">
                    <div class="custom-container-basis-lg custom-container-shadow d-flex flex-column align-items-start gap-2 round-20 color-bg-primary p-3 p-lg-4 mb-1 mb-lg-0">
                        <SvgSprite class="icon color-icon-brand color-bg-brand p-2 round-12 mb-3 mb-lg-2" symbol="www-filled" width="24" height="24"/>
                        <h3 class="text-title-bold text-headline2-md-semibold color-text-primary user-select-none">
                            {{ t('aboutPage.main.work.section1.grid1.title') }}
                        </h3>
                        <p class="text-body-regular color-text-primary user-select-none">
                            {{ t('aboutPage.main.work.section1.grid1.paragraph') }}
                        </p>
                    </div>
                    <div class="custom-container-basis-lg custom-container-shadow d-flex flex-column align-items-start gap-2 round-20 color-bg-primary p-3 p-lg-4 mb-1 mb-lg-0">
                        <SvgSprite class="icon color-icon-brand color-bg-brand p-2 round-12 mb-3 mb-lg-2" symbol="users-filled" width="24" height="24"/>
                        <h3 class="text-title-bold text-headline2-md-semibold color-text-primary user-select-none">
                            {{ t('aboutPage.main.work.section1.grid2.title') }}
                        </h3>
                        <p class="text-body-regular color-text-primary user-select-none">
                            {{ t('aboutPage.main.work.section1.grid2.paragraph') }}
                        </p>
                    </div>
                    <div class="custom-container-basis-lg custom-container-shadow d-flex flex-column align-items-start gap-2 round-20 color-bg-primary p-3 p-lg-4 mb-1 mb-lg-0">
                        <SvgSprite class="icon color-icon-brand color-bg-brand p-2 round-12 mb-3 mb-lg-2" symbol="webmoney" width="24" height="24"/>
                        <h3 class="text-title-bold text-headline2-md-semibold color-text-primary user-select-none">
                            {{ t('aboutPage.main.work.section1.grid3.title') }}
                        </h3>
                        <p class="text-body-regular color-text-primary user-select-none">
                            {{ t('aboutPage.main.work.section1.grid3.paragraph') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column gap-5 ps-sm-4 pe-sm-4 ps-lg-0 pe-lg-0">
                <div class="d-flex flex-column flex-lg-row align-items-lg-center gap-2 gap-lg-4 pt-2 mt-4">
                    <img class="custom-image-main flex-shrink-0 user-select-none w-100 mb-1 mb-lg-0 m-auto" :src="`images/about-content-image-2-${lang}.webp`" alt="Изображение для блока 'Одна почта - неограниченное количество псевдонимов'">
                    <div class="custom-container-main d-flex flex-column gap-2 pe-lg-4">
                        <h3 class="custom-title custom-text-headline-xl-bold text-title-bold text-headline2-sm-bold color-text-primary text-center text-lg-start user-select-none mb-1 mb-lg-1 m-auto m-lg-0">
                            {{ t('aboutPage.main.work.section2.grid1.title') }}
                        </h3>
                        <p class="text-body-regular text-body2-xl-regular color-text-primary text-center text-md-start user-select-none">
                            {{ t('aboutPage.main.work.section2.grid1.paragraph') }}
                        </p>
                    </div>
                </div>
                <div class="d-flex flex-column flex-lg-row-reverse align-items-lg-center gap-2 gap-lg-4 pt-2 mt-4">
                    <img class="custom-image-main flex-shrink-0 user-select-none w-100 mb-1 mb-lg-0 me-lg-4 m-auto" :src="`images/about-content-image-3-${lang}.webp`" alt="Изображение для блока 'Получайте и отправляйте защифрованные письма'">
                    <div class="custom-container-main d-flex flex-column gap-2">
                        <h3 class="custom-title custom-text-headline-xl-bold text-title-bold text-headline2-sm-bold color-text-primary text-center text-lg-start user-select-none mb-1 mb-lg-1 m-aut m-lg-0">
                            {{ t('aboutPage.main.work.section2.grid2.title') }}
                        </h3>
                        <p class="text-body-regular text-body2-xl-regular color-text-primary text-center text-md-start user-select-none">
                            {{ t('aboutPage.main.work.section2.grid2.paragraph') }}
                        </p>
                    </div>
                </div>
                <div class="d-flex flex-column flex-lg-row align-items-lg-center gap-2 gap-lg-4 pt-2 mt-4">
                    <img class="custom-image-main flex-shrink-0 user-select-none w-100 mb-1 mb-lg-0 m-auto" :src="`images/about-content-image-4-${lang}.webp`" alt="Изображение для блока 'Читайте все письма в одном месте'">
                    <div class="custom-container-main d-flex flex-column gap-2 pe-lg-4">
                        <h3 class="custom-title custom-text-headline-xl-bold text-title-bold text-headline2-sm-bold color-text-primary text-center text-lg-start user-select-none mb-1 mb-lg-1 m-auto m-lg-0">
                            {{ t('aboutPage.main.work.section2.grid3.title') }}
                        </h3>
                        <p class="text-body-regular text-body2-xl-regular color-text-primary text-center text-md-start user-select-none">
                            {{ t('aboutPage.main.work.section2.grid3.paragraph') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom-container-figure-mask">
            <div class="custom-container d-flex flex-column gap-5 pt-2 pb-5 ps-3 pe-3 ps-md-4 pe-md-4 mt-4 m-auto">
                <div class="custom-container-shadow position-relative d-flex flex-column flex-md-row flex-md-wrap color-bg-primary round-28 pt-4 pb-4 ps-3 pe-3 ps-sm-4 pe-sm-4 mt-5 mb-2">
                    <img class="custom-image-security user-select-none flex-shrink-0 order-md-3 mb-1 mb-md-auto m-auto m-md-auto" src="images/about-content-image-5.webp" alt="Изображение для блока 'Ваша переписка в безопасности'">
                    <h3 class="custom-title custom-text-headline-xl-bold text-headline2-bold text-headline-md-bold color-text-primary text-center text-md-start user-select-none w-100 order-md-1 pt-md-2 pb-2 pb-md-0 ps-md-2 pe-md-2 mb-4 m-auto">
                        {{ t('aboutPage.main.security.title') }}
                    </h3>
                    <ul class="custom-container-security d-flex flex-column gap-3 order-md-2 pb-3 pb-sm-0 pb-md-2 ps-md-2 pe-md-2 me-md-2">
                        <li class="d-flex align-items-start gap-3 mb-1">
                            <SvgSprite class="icon color-icon-brand color-bg-brand p-2 round-12 mb-3" symbol="shield-filled" width="24" height="24"/>
                            <p class="text-body-regular text-body2-xl-regular color-text-secondary text-start user-select-none">
                                {{ t('aboutPage.main.security.list.paragraph1') }}
                            </p>
                        </li>
                        <li class="d-flex align-items-start gap-3 mb-1">
                            <SvgSprite class="icon color-icon-brand color-bg-brand p-2 round-12 mb-3" symbol="hand-filled" width="24" height="24"/>
                            <p class="text-body-regular text-body2-xl-regular color-text-secondary text-start user-select-none">
                                {{ t('aboutPage.main.security.list.paragraph2') }}
                            </p>
                        </li>
                        <li class="d-flex align-items-start gap-3 mb-1">
                            <SvgSprite class="icon color-icon-brand color-bg-brand p-2 round-12 mb-3" symbol="lock-filled" width="24" height="24"/>
                            <p class="text-body-regular text-body2-xl-regular color-text-secondary text-start user-select-none">
                                {{ t('aboutPage.main.security.list.paragraph3') }}
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="d-flex flex-column gap-4 mt-4">
                    <h3 class="custom-title custom-text-headline1-sm-bold custom-text-display1-xl-bold text-headline2-bold color-text-contrast-light text-center user-select-none mb-2 m-auto">
                        {{ t('aboutPage.main.other.title') }}
                    </h3>
                    <div class="d-flex flex-column flex-md-row flex-md-wrap flex-lg-nowrap justify-content-between gap-4 flex-fill">
                        <div class="custom-container-basis-md custom-container-basis-lg d-flex flex-column align-items-start gap-3 flex-grow-1 color-bg-shadow round-20 round-sm-28 p-3 p-sm-4">
                            <div class="custom-container-image color-bg-gradient w-100 round-12 overflow-hidden pt-3 pb-3 ps-4 pe-4 mb-1">
                                <div class="d-flex flex-column gap-2 pt-1 pb-1">
                                    <SvgSprite class="icon mb-lg-1 ms-2" symbol="wm-files" width="165" height="32"/>
                                    <img class="custom-image-files position-relative align-self-end user-select-none" src="images/about-content-image-6.webp" alt="Изображение для блока 'WebMoney Files'">
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-start gutter-row-1">
                                <h3 class="text-headline2-semibold color-text-contrast-light text-center user-select-none mb-1">
                                    {{ t('aboutPage.main.other.grid1.title') }}
                                </h3>
                                <p class="text-body-regular color-text-contrast-light text-start user-select-none mb-1">
                                    {{ t('aboutPage.main.other.grid1.paragraph') }}
                                </p>
                            </div>
                            <a class="button button--stroke w-auto pt-2 pb-2 ps-3 pe-3 mt-auto" href="https://files.web.money/" target="_blank">
                                <span class="button__text text-footnote-semibold ps-1 pe-1">
                                    {{ t('aboutPage.main.other.linkText') }}
                                </span>
                            </a>
                        </div>
                        <div class="custom-container-basis-md custom-container-basis-lg d-flex flex-column align-items-start gap-3 flex-grow-1 color-bg-shadow round-20 round-sm-28 p-3 p-sm-4">
                            <div class="custom-container-image color-bg-gradient w-100 round-12 overflow-hidden pt-3 pb-3 ps-4 pe-4 mb-1">
                                <div class="d-flex flex-column gap-2 pt-1 pb-1">
                                    <SvgSprite class="icon mb-lg-1 ms-2" symbol="memo" width="139" height="32"/>
                                    <img class="custom-image-memo position-relative align-self-end user-select-none" src="images/about-content-image-7.webp" alt="Изображение для блока 'WebMoney Files'">
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-start gutter-row-1">
                                <h3 class="text-headline2-semibold color-text-contrast-light text-center user-select-none mb-1">
                                    {{ t('aboutPage.main.other.grid2.title') }}
                                </h3>
                                <p class="text-body-regular color-text-contrast-light text-start user-select-none mb-1">
                                    {{ t('aboutPage.main.other.grid2.paragraph') }}
                                </p>
                            </div>
                            
                            <a class="button button--stroke w-auto pt-2 pb-2 ps-3 pe-3 mt-auto" href="https://memo.web.money/" target="_blank">
                                <span class="button__text text-footnote-semibold ps-1 pe-1">
                                    {{ t('aboutPage.main.other.linkText') }}
                                </span>
                            </a>
                        </div>
                        <div class="custom-container-basis-md custom-container-basis-lg d-flex flex-column align-items-start gap-3 flex-grow-1 color-bg-shadow round-20 round-sm-28 p-3 p-sm-4">
                            <div class="custom-container-image color-bg-gradient w-100 round-12 overflow-hidden pt-3 pb-3 ps-4 pe-4 mb-1">
                                <div class="d-flex flex-column gap-2 position-relative pt-1 pb-1">
                                    <SvgSprite class="icon mb-lg-1 ms-2" symbol="notes" width="140" height="28"/>
                                    <img class="custom-image-notes position-relative align-self-end user-select-none" src="images/about-content-image-8.webp" alt="Изображение для блока 'WebMoney Files'">
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-start gutter-row-1">
                                <h3 class="text-headline2-semibold color-text-contrast-light text-center user-select-none mb-1">
                                    {{ t('aboutPage.main.other.grid3.title') }}
                                </h3>
                                <p class="text-body-regular color-text-contrast-light text-start user-select-none mb-1">
                                    {{ t('aboutPage.main.other.grid3.paragraph') }}
                                </p>
                            </div>
                            
                            <a class="button button--stroke w-auto pt-2 pb-2 ps-3 pe-3 mt-auto" href="https://notes.web.money/" target="_blank">
                                <span class="button__text text-footnote-semibold ps-1 pe-1">
                                    {{ t('aboutPage.main.other.linkText') }}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column gap-3 pt-4 mt-5 mt-md-5 m-md-auto" id="faq">
                    <h3 class="custom-text-headline1-sm-bold custom-text-display1-xl-bold text-headline2-bold color-text-contrast-light text-center user-select-none mb-3 ">
                        {{ t('aboutPage.main.faq.title') }}
                    </h3>

                    <div class="custom-container-faq color-bg-shadow round-16 p-3 p-sm-4">
                        <div class="custom-accordion-item button d-inline-flex align-items-start justify-content-between w-100 user-select-none p-0" data-bs-toggle="collapse" data-bs-target="#faq-1" aria-expanded="true" aria-controls="faq">
                            <span class="custom-accordion-item__text text-body-bold text-title-sm-semibold text-start user-select-none flex-grow-1">
                                {{ t('aboutPage.main.faq.question1.title') }}
                            </span>
                            
                            <SvgSprite class="icon color-icon-contrast-light" symbol="arrow-dropdown" width="24" height="24"/>
                        </div>
                        <div id="faq-1" class="collapse show" aria-labelledby="Ответ к вопросу 'Как перенести письма с других ящиков в WebMoney Mail?'">
                            <p class="text-footnote-regular text-body-sm-regular color-text-contrast-light user-select-none pt-1 mt-2">
                                <a class="custom-link custom-link--default" @click="toCollector" target="_blank">
                                    <span class="text-footnote-regular text-body-sm-regular">
                                        {{ t('aboutPage.main.faq.question1.linkText') }}
                                    </span>
                                </a>
                                {{ t('aboutPage.main.faq.question1.paragraph') }}
                            </p>
                        </div>
                    </div>
                    <div class="custom-container-faq color-bg-shadow round-16 p-3 p-sm-4">
                        <div class="custom-accordion-item button d-inline-flex align-items-start justify-content-between w-100 user-select-none p-0 collapsed" data-bs-toggle="collapse" data-bs-target="#faq-2" aria-expanded="true" aria-controls="faq">
                            <span class="custom-accordion-item__text text-body-bold text-title-sm-semibold text-start user-select-none flex-grow-1">{{ t('aboutPage.main.faq.question2.title') }}</span>
                            
                            <SvgSprite class="icon color-icon-contrast-light" symbol="arrow-dropdown" width="24" height="24"/>
                        </div>
                        <div id="faq-2" class="collapse" aria-labelledby="Ответ к вопросу 'Какой объем памяти доступен в WebMoney Mail?'">
                            <p class="text-footnote-regular text-body-sm-regular color-text-contrast-light user-select-none pt-1 mt-2">
                                {{ t('aboutPage.main.faq.question2.paragraph') }}
                                <a class="custom-link custom-link--default" href="https://files.web.money/" target="_blank">
                                    <span class="text-footnote-regular text-body-sm-regular">
                                        {{ t('aboutPage.main.faq.question2.linkText') }}
                                    </span>
                                </a>
                            </p>
                        </div>
                    </div>
                    <div class="custom-container-faq color-bg-shadow round-16 p-3 p-sm-4">
                        <div class="custom-accordion-item button d-inline-flex align-items-start justify-content-between w-100 user-select-none p-0 collapsed" data-bs-toggle="collapse" data-bs-target="#faq-3" aria-expanded="true" aria-controls="faq">    
                            <span class="custom-accordion-item__text text-body-bold text-title-sm-semibold text-start user-select-none flex-grow-1">
                                {{ t('aboutPage.main.faq.question3.title') }}
                            </span>

                            <SvgSprite class="icon color-icon-contrast-light" symbol="arrow-dropdown" width="24" height="24"/>
                        </div>
                        <div id="faq-3" class="collapse" aria-labelledby="Контент к вопросу 'Сколько псевдонимов можно создать?'">
                            <p class="text-footnote-regular text-body-sm-regular color-text-contrast-light user-select-none pt-1 mt-2">
                                {{ t('aboutPage.main.faq.question3.paragraph.part1') }}
                                <span class="text-footnote-semibold text-body1-sm-bold">
                                    {{ t('aboutPage.main.faq.question3.paragraph.highlightedText1') }}
                                </span>  
                                {{ t('aboutPage.main.faq.question3.paragraph.part2') }}
                                <span class="text-footnote-semibold text-body1-sm-bold">
                                    {{ t('aboutPage.main.faq.question3.paragraph.highlightedText2') }}
                                </span>
                                {{ t('aboutPage.main.faq.question3.paragraph.part3') }}
                                <span class="text-footnote-semibold text-body1-sm-bold">
                                    {{ t('aboutPage.main.faq.question3.paragraph.highlightedText3') }}
                                </span> 
                                {{ t('aboutPage.main.faq.question3.paragraph.part4') }}
                                <span class="text-footnote-semibold text-body1-sm-bold">
                                    {{ t('aboutPage.main.faq.question3.paragraph.highlightedText4') }}
                                </span>
                                {{ t('aboutPage.main.faq.question3.paragraph.part5') }}
                            </p>
                        </div>
                    </div>
                    <div class="custom-container-faq color-bg-shadow round-16 p-3 p-sm-4">
                        <div class="custom-accordion-item button d-inline-flex align-items-start justify-content-between w-100 user-select-none p-0 collapsed" data-bs-toggle="collapse" data-bs-target="#faq-4" aria-expanded="true" aria-controls="faq">
                            <span class="custom-accordion-item__text text-body-bold text-title-sm-semibold text-start user-select-none flex-grow-1">
                                {{ t('aboutPage.main.faq.question4.title') }}
                            </span>

                            <SvgSprite class="icon color-icon-contrast-light" symbol="arrow-dropdown" width="24" height="24"/>
                        </div>
                        <div id="faq-4" class="collapse" aria-labelledby="Контент к вопросу 'Какого размера файлы можно прикреплять к письму?'">
                            <p class="text-footnote-regular text-body-sm-regular color-text-contrast-light user-select-none pt-1 mt-2">
                                {{ t('aboutPage.main.faq.question4.paragraph') }}
                            </p>
                        </div>
                    </div>
                    <div class="custom-container-faq color-bg-shadow round-16 p-3 p-sm-4">
                        <div class="custom-accordion-item button d-inline-flex align-items-start justify-content-between w-100 user-select-none p-0 collapsed" data-bs-toggle="collapse" data-bs-target="#faq-5" aria-expanded="true" aria-controls="faq">
                            <span class="custom-accordion-item__text text-body-bold text-title-sm-semibold text-start user-select-none flex-grow-1">
                                {{ t('aboutPage.main.faq.question5.title') }}
                            </span>

                            <SvgSprite class="icon color-icon-contrast-light" symbol="arrow-dropdown" width="24" height="24"/>
                        </div>
                        <div id="faq-5" class="collapse" aria-labelledby="Контент к вопросу 'Как подключить свой домен к почте WebMoney?'">
                            <p class="text-footnote-regular text-body-sm-regular color-text-contrast-light user-select-none pt-1 mt-2">
                                {{ t('aboutPage.main.faq.question5.paragraph') }}
                            
                                <span class="text-footnote-semibold text-body1-sm-bold">
                                    {{ t('aboutPage.main.faq.question5.highlightedText') }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
<!--    <footer class="footer" id="webMoneyFooter"></footer>-->
</template>
<script>
export default {
  inheritAttrs: false
}
</script>
<script setup>
import {computed, onMounted, onUnmounted} from "vue";
import { useI18n } from 'vue-i18n'
import {useStore} from "vuex";
import {loadWM} from "@/components/helpers/LoadWM";
import {setCookie} from "@/components/helpers/CookiesHelper";
// import router from "@/router";

const
  $store = useStore(),
  $emit = defineEmits(['onload_page', 'change_status']),
  {t} = useI18n(),
  lang = computed(() => $store.getters['getLanguage'])

function goToMail(){
  // const path = $store.getters['user'].Info ? "/mail" : "/login"
  const path = $store.getters['user'].Info ? "/mail" : "/login"

  setCookie('redirect', "/mail", {secure: true, 'max-age': 72000})

  window.location.href = path
}

function toCollector(){
  window.location.href = "/settings/collectors"

  // const path = $store.getters['user'].Info ? "/settings/collectors" : "/login"
  //
  // setCookie('redirect', "/settings/collectors", {secure: true, 'max-age': 72000})
  //
  // window.location.href = path
}

// function removeFooter(){
//   const footer = document.getElementById('webMoneyFooter')
//   if(footer){
//     footer.remove()
//   }
// }

async function load(){
  const footer = document.getElementById('webMoneyFooter')

  // removeFooter()
  try {
    const email = $store.getters['user'].Email
    const userAlias = $store.getters['user'].Info?.alias || ''
    // console.log('$store.getters[user].Info', $store.getters['user'].Info)
    const resp = await $store.dispatch('getRid')
    if (resp) {
      const em = userAlias || email?.substr(0, 12) || ''
      loadWM(em, lang.value, resp, !footer.firstChild)
    }
  } catch (err) {
    console.log('error :>> ', err);
  }
}

onMounted(async ()=> {
  await load()
  // loadWMFooter(lang.value)
  // loadWMFooter(lang.value)
  // $emit('change_status', 'failed')
  $emit('onload_page')

  const elems = document.getElementsByClassName('webmoney-header')
  // console.log('elems[0]', elems[0])
  if(elems[0]) {
    elems[0].classList.add('about-header')
  }
  const elements = document.getElementsByClassName('main')
  if(elements[0]){
    elements[0].classList.add('about-main')
  }
})

onUnmounted(() => {
  const elems = document.getElementsByClassName('webmoney-header')
  if(elems[0]) {
    elems[0].classList.remove('about-header')
  }
  const elements = document.getElementsByClassName('main')
  if(elements[0]){
    elements[0].classList.remove('about-main')
  }
  // removeFooter()
})

</script>
<style lang="scss">
    body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .about-header {
        display: block;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 100;
        box-shadow: var(--shadow);
    }
    .about-main{
        overflow-y: unset;
        height: unset;
    }
</style>
